// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"922a6d47","239":"2bb65f6e","368":"01556f85","630":"eead7ea3","696":"dc69c1d1","774":"e741ec3d","801":"d66feb06","812":"9cd342c2"}[chunkId] + ".chunk.js";
};